import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthguardService } from '../shared/services/authguard.service';

import { DynamicPage } from './dynamic.page';

const routes: Routes = [
  {
    path: 'app',
    component: DynamicPage,
    children: [
      {
        path: 'deals',
        canActivate: [AuthguardService],
        loadChildren: () =>
          import('./pages/deals/deals.module').then(
            (m) => m.DealsPageModule
          ),
      },
      {
        path: 'clients',
        canActivate: [AuthguardService],
        loadChildren: () =>
          import('./pages/clients/clients.module').then(
            (m) => m.ClientsPageModule
          ),
      },
      {
        path: 'manage',
        canActivate: [AuthguardService],
        loadChildren: () =>
          import('./pages/manage/manage.module').then(
            (m) => m.ManagePageModule
          ),
      },
      {
        path: 'conveyancy-dashboard',
        canActivate: [AuthguardService],
        loadChildren: () =>
          import('./pages/conveyancy-dashboard/conveyancy-dashboard.module').then(
            (m) => m.ConveyancyDashboardPageModule
          ),
      },
      {
        path: 'finance',
        canActivate: [AuthguardService],
        loadChildren: () =>
          import('./pages/finance-dashboard/finance-dashboard.module').then(
            (m) => m.FinanceDashboardPageModule
          ),
      },
      {
        path: 'reports',
        canActivate: [AuthguardService],
        loadChildren: () =>
          import('./pages/report-dashboard/report-dashboard.module').then(
            (m) => m.ReportDashboardPageModule
          ),
      },
      {
        path: 'documents',
        canActivate: [AuthguardService],
        loadChildren: () =>
          import('./pages/documents/documents.module').then(
            (m) => m.DocumentsModule
          ),
      },
      {
        path: 'agent-dashboard',
        canActivate: [AuthguardService],
        loadChildren: () =>
          import('./pages/agent-dashboard/agent-dashboard.module').then(
            (m) => m.AgentDashboardPageModule
          ),
      },
      {
        path: 'user-information',
        canActivate: [AuthguardService],
        loadChildren: () =>
          import('./pages/user-information/user-information.module').then(
            (m) => m.UserInformationPageModule
          ),
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class DynamicPageRoutingModule {}
